import { css, Flex, styled } from '@chilipiper/design-system'

export const StyledBookMeetingContainer = styled(Flex)`
  border: 1px solid ${({ theme }) => theme.colors['white-12']};
  background: ${({ theme }) => theme.colors['white-4']};

  [data-chili-css='chat-light-theme'] & {
    border: 1px solid ${({ theme }) => theme.colors['neutral-dark-8']};
    background: ${({ theme }) => theme.colors['neutral-dark-4']};
  }
`
export const customerColorCss = css`
  color: rgb(var(--primary-contrast-color));
  background-color: rgb(var(--primary-color));
`
